// extracted by mini-css-extract-plugin
export default {"wrapper":"SlotRangeInput_wrapper__6GGuG","selectWrapper":"SlotRangeInput_selectWrapper__1vTXC"};